/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const countRateTotal = (dividend: number, denominator: number) => {
  if (denominator && dividend) {
    return ((dividend * 100) / denominator).toFixed(2)
  }
  return '0'
}

export const countRate = <T extends string>(
  rated: T,
  dividend: number,
  denominator: number
) => {
  const key = rated

  if (denominator && dividend) {
    const rate = ((dividend * 100) / denominator).toFixed(2)

    return { [key]: rate } as Record<T, string>
  }
  return { [key]: '0' } as Record<T, string>
}
